// extracted by mini-css-extract-plugin
module.exports = {"md":"bonus-home-slot-delay_md_16sFS","ios":"bonus-home-slot-delay_ios_1st4Z","wrapper":"bonus-home-slot-delay_wrapper_3FJih","content":"bonus-home-slot-delay_content_3kUfi"};